<template>
  <div>
    <div class="filters_listing version_3">
      <div class="container-fluid">
        <ul class="clearfix">
          <li>
            <div class="switch-field">
              <input
                id="featured"
                v-model="newOrder"
                type="radio"
                name="order_filter"
                value="relevance"
                :checked="newOrder === 'relevance'"
                @click="$emit('orderChanged', 'relevance')"
              >
              <label for="featured">{{ $t('lang.search.filters.relevance') }}</label>

              <input
                id="closest"
                v-model="newOrder"
                type="radio"
                name="order_filter"
                value="distance"
                :checked="newOrder === 'distance'"
                @click="$emit('orderChanged', 'distance')"
              >
              <label for="closest">{{ $tc('lang.search.filters.distance') }}</label>
            </div>
          </li>
          <li>
            <a
              class="btn_filt_map"
              data-toggle="collapse"
              href="#filters"
              aria-expanded="false"
              aria-controls="filters"
              data-text-swap="Less filters"
              data-text-original="More filters"
            >
              {{ $t('lang.search.filters.more_filters') }}
            </a>
          </li>
        </ul>
      </div>
      <!-- /container -->
    </div>

    <div
      id="filters"
      class="collapse map_view"
    >
      <div class="container-fluid">
        <!--                <h6>Horarios</h6>-->
        <div class="row">
          <div
            class="col-md-12 text-right"
            style="padding-top: 10px"
          >
            <label
              class="container_radio"
              style="color: rgba(0,0,0,0.5)"
              @click="emptyFilters"
            >
              {{ $t('lang.search.filters.empty') }}
            </label>
          </div>
          <div class="col-md-6 margin_bottom_10">
            <ul class="margin_bottom_10">
              <li>
                <label class="container_radio">{{ $t('lang.search.filters.open') }}
                  <small>{{ filterValues.open }}</small>
                  <input
                    id="open"
                    v-model="newFilters.open"
                    type="radio"
                    name="schedule"
                    value="open"
                    :checked="newFilters.open === 'open'"
                  >
                  <span class="checkmark" />
                </label>
              </li>

              <li>
                <label class="container_radio">{{ $t('lang.search.filters.closed') }}
                  <small>{{ filterValues.close }}</small>
                  <input
                    id="close"
                    v-model="newFilters.open"
                    type="radio"
                    name="schedule"
                    value="close"
                    :checked="newFilters.open === 'close'"
                  >
                  <span class="checkmark" />
                </label>
              </li>

              <li>
                <label
                  class="container_radio"
                  style="color: rgba(0,0,0,0.5)"
                >{{ $t('lang.search.filters.all') }}
                  <input
                    id="all"
                    v-model="newFilters.open"
                    type="radio"
                    name="schedule"
                    value="all"
                    :checked="newFilters.open != 'open' && newFilters.open != 'close' "
                  >
                  <span class="checkmark" />
                </label>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="margin_bottom_10">
              <li>
                <label class="container_check">{{ $t('lang.search.filters.recommended') }}
                  <small>{{ filterValues.recommended }}</small>
                  <input
                    v-model="newFilters.recommended"
                    type="checkbox"
                    :checked="newFilters.recommended"
                  >
                  <span class="checkmark" />
                </label>
              </li>
              <li>
                <label class="container_check d-inline-block">
                  {{ $tc('lang.search.filters.less_than', 1) }}
                  <input
                    v-model="newFilters.less_than"
                    type="checkbox"
                    :checked="newFilters.less_than"
                  >
                  <span class="checkmark" />
                </label>
                <input
                  id="less_than"
                  v-model="newFilters.distance"
                  type="number"
                  class="form-control d-inline-block"
                  min="1"
                  max="10"
                  style="width: 22%; margin: 0px 5px 0px 5px"
                >
                <label class="d-inline-block">{{ $tc('lang.search.filters.less_than', 2) }}
                </label>
                <div class="slidecontainer">
                  <input
                    id="myRange"
                    v-model="newFilters.distance"
                    type="range"
                    min="1"
                    max="10"
                    value="1"
                    class="slider"
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
        <h6>{{ $t('lang.categories.categories') }}</h6>
        <div
          class="row"
          style="margin-bottom: 2rem"
        >
          <div
            v-for="(category,index) in this.$globalCategories"
            v-if="filterValues[index]"
            :key="index"
            class="col-md-6"
          >
            <ul style="margin-bottom: 0">
              <li>
                <label class="container_radio">{{ $t('lang.categories.'+index) }}
                  <small>{{ filterValues[index] }}</small>
                  <input
                    :id="index"
                    v-model="newFilters.category"
                    type="radio"
                    name="categories"
                    :value="index"
                    :checked="newFilters.category === index"
                  >
                  <span class="checkmark" />
                </label>
              </li>
            </ul>
          </div>

          <div
            key="all"
            class="col-md-6"
          >
            <ul style="margin-bottom: 0">
              <li>
                <label
                  class="container_radio"
                  style="color: rgba(0,0,0,0.5)"
                >{{ $t('lang.search.filters.all') }}
                  <input
                    id="all"
                    v-model="newFilters.category"
                    type="radio"
                    name="categories"
                    value="all"
                    :checked="newFilters.category === '' || newFilters.category === null"
                  >
                  <span class="checkmark" />
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchFilters',

  props: {
    filters: {
      type: Object,
      required: true,
    },
    order: {
      type: String,
      required: true,
    },
    filterValues: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newFilters: JSON.parse(JSON.stringify(this.filters)),
      initialFilters: JSON.parse(JSON.stringify(this.filters)),
      newOrder: this.order,
    };
  },

  watch: {
    newFilters: {
      deep: true,
      handler(newFilters) {
        this.$emit('filtersChanged', newFilters);
      },
    },
  },
  methods: {
    emptyFilters() {
      this.newFilters = JSON.parse(JSON.stringify(this.initialFilters));
      this.$emit('emptyFilters');
    },
  },
};
</script>

<style scoped>
</style>
